export default {
    title: 'Filter selection',
    button: {
        cancel: 'Close'
    }
}
